var _rect, _text, _rect2, _circle, _text2, _text3, _rect3, _rect4, _rect5, _circle2, _text4, _rect6, _circle3, _text5, _text6, _rect7, _circle4, _rect8, _rect9, _rect0, _text7, _rect1, _circle5, _text8, _text9, _rect10, _path, _circle6, _circle7, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentProductProofSaasSuiteMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 700,
    viewBox: "0 0 360 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AndUs SaaS product proof suite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 698,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 39,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850,
    letterSpacing: 1.1
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    dy: 0
  }, "THREE SYSTEMS \xB7 THREE OPERATING PROBLEMS"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 65,
    width: 312,
    height: 188,
    rx: 20,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 92,
    r: 8,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 97,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "Unity Learning")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 119,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "Structured, evidence-based learning")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 130,
    width: 276,
    height: 70,
    rx: 12,
    fill: "#EEF7FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 146,
    width: 248,
    height: 8,
    rx: 4,
    fill: "#C5DFF5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 164,
    width: 183.52,
    height: 8,
    rx: 4,
    fill: "#087CFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 187,
    r: 8,
    fill: "#087CFF"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 233,
    fill: "#087CFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850,
    letterSpacing: 0.6
  }, "LIVE ANDUS SAAS PRODUCT")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 267,
    width: 312,
    height: 188,
    rx: 20,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 294,
    r: 8,
    fill: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 299,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "TalentLenz")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 321,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "Opportunity-specific applicant assessment")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 332,
    width: 276,
    height: 70,
    rx: 12,
    fill: "#FFF1F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 357,
    r: 11,
    fill: "#FF2775",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 349,
    width: 208,
    height: 7,
    rx: 3.5,
    fill: "#E6C5D3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 365,
    width: 180,
    height: 7,
    rx: 3.5,
    fill: "#FF2775"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 378,
    width: 30,
    height: 14,
    rx: 7,
    fill: "#FF2775"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 435,
    fill: "#FF2775",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850,
    letterSpacing: 0.6
  }, "LIVE ANDUS SAAS PRODUCT")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 469,
    width: 312,
    height: 188,
    rx: 20,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 496,
    r: 8,
    fill: "#17A9C6"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 501,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "FleetCore")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 523,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "Verified fleet and fuel accountability")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 534,
    width: 276,
    height: 70,
    rx: 12,
    fill: "#EFFBF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 582c28-42 62 10 94-23s55 15 84-11",
    fill: "none",
    stroke: "#17A9C6",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 582,
    r: 5,
    fill: "#17A9C6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 294,
    cy: 551,
    r: 5,
    fill: "#17A9C6"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 637,
    fill: "#17A9C6",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850,
    letterSpacing: 0.6
  }, "LIVE ANDUS SAAS PRODUCT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentProductProofSaasSuiteMobile);
export default __webpack_public_path__ + "static/media/custom-development-product-proof-saas-suite-mobile.c3d32a91c6a5783b76599c91ccc80bcb.svg";
export { ForwardRef as ReactComponent };